import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import PriorAttainmentViewModel from '../ViewModels/PriorAttainmentViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IPriorAttainmentProps {
    setPriorAttainment?: (event) => void;
    priorAttainment: string | undefined;
    disabled: boolean;
}

interface IPriorAttainmentState {
    model: PriorAttainmentViewModel[];
    loaded: boolean;
}

class PriorAttainment extends Component<IPriorAttainmentProps & WithStyles<typeof styles>, IPriorAttainmentState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetPriorAttainmentLevels').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultPriorAttainmentVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <React.Fragment>
                <SelectValidator
                    label="What is the highest level of qualification you hold (or equivalent to)?"
                    name="priorAttainment"
                    select
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    value={this.props.priorAttainment}
                    onChange={this.props.disabled ? undefined : this.props.setPriorAttainment}
                    disabled={this.props.disabled}
                    validators={['required']}
                    errorMessages={['This field is required']}
                    InputProps={{
                        disabled: !this.state.loaded,
                        startAdornment: (
                            <React.Fragment>
                                {this.state.loaded ? null : <CircularProgress size={20} />}
                            </React.Fragment>
                        ),
                        readOnly: this.props.disabled
                    }}
                >
                    {items}
                </SelectValidator>
                {this.props.priorAttainment !== undefined &&
                    <p>{this.state.model.filter(x => x.value === this.props.priorAttainment)[0].extraDescription}</p>
                }
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(PriorAttainment);